import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "transaction-detail-page" }

import { ref, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'
import FuelingTransactionDetailCard from '@/views/shared-components/FuelingTransactionDetailCard.vue'
import { encryptDecriptMethods } from '@/plugins/encryptDecriptMethods'
import { useFuelTransactionDetail } from '@/composables/pages/externals/fuel-monitoring/useFuelTransactionDetail'
import apiUseCase from '@/usecase/apiUseCase'


export default /*#__PURE__*/_defineComponent({
  __name: 'Detail',
  setup(__props) {

const route = useRoute()
const router = useRouter()
const store = useStore()

const {
  isLoadingDetail,
  isLoadingHistory,
  transactionDetail,
  historyData,
  activeHistoryTab,
  historyPaginate,
  onChangeHistoryTab,
  onChangeHistoryPage,
  fetchHistory
} = useFuelTransactionDetail()

// Collapsible history: default hidden
const isHistoryVisible = ref(false)

const toggleHistory = () => {
  isHistoryVisible.value = !isHistoryVisible.value
  // Fetch history data on first show
  if (isHistoryVisible.value && historyData.value.length === 0 && transactionDetail.value) {
    fetchHistory()
  }
}

const fetchDetailData = async (id: string) => {
  isLoadingDetail.value = true
  try {
    const response = await apiUseCase.get(`/transaction/v2/FuelingTransactions/${id}`)
    if (!response.error) {
      transactionDetail.value = response.result

      // Update breadcrumbs once we have the code
      store.dispatch('ui/setBreadcrumbs', [
        { title: 'Monitoring Transaksi', routeName: 'fuel-monitoring' },
        { title: response.result.Code, routeName: 'fuel-monitoring-detail' }
      ])
    }
  } catch (err) {
    console.error(err)
  } finally {
    isLoadingDetail.value = false
  }
}

const goBack = () => {
  router.push({ name: 'fuel-monitoring' })
}

onMounted(() => {
  // Set initial breadcrumb while loading
  store.dispatch('ui/setBreadcrumbs', [
    { title: 'Monitoring Transaksi', routeName: 'fuel-monitoring' },
    { title: 'Detail Transaksi', routeName: 'fuel-monitoring-detail' }
  ])

  if (route.params.id) {
    try {
      // Decrypt ID
      const decryptedData = encryptDecriptMethods.decrypt(route.params.id as string)
      const id = typeof decryptedData === 'string' ? decryptedData : (decryptedData.Id || decryptedData)

      // Initialize tab and fetch data
      activeHistoryTab.value = 'nopol'
      historyPaginate.value.pageNumber = 1

      fetchDetailData(id)
    } catch (e) {
      console.error('Error decrypting route param', e)
    }
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(FuelingTransactionDetailCard, {
      transactionDetail: _unref(transactionDetail),
      isLoadingDetail: _unref(isLoadingDetail),
      historyData: _unref(historyData),
      isLoadingHistory: _unref(isLoadingHistory),
      activeHistoryTab: _unref(activeHistoryTab),
      historyPaginate: _unref(historyPaginate),
      isHistoryVisible: isHistoryVisible.value,
      onToggleHistory: toggleHistory,
      onChangeHistoryTab: _unref(onChangeHistoryTab),
      onChangeHistoryPage: _unref(onChangeHistoryPage),
      onBack: goBack
    }, null, 8, ["transactionDetail", "isLoadingDetail", "historyData", "isLoadingHistory", "activeHistoryTab", "historyPaginate", "isHistoryVisible", "onChangeHistoryTab", "onChangeHistoryPage"])
  ]))
}
}

})